import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { ProductCardList as ProductCardListUI } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import styles from './ProductCardsSkeleton.scss';

export interface ProductCardsSkeletonProps {
  numCards?: number;
  dataHook?: string;
  isAiRecommendationEnabled?: boolean;
}

const DEFAULT_LAYOUT = {
  height: '483px',
  borderRadius: '12px',
  maxWidth: undefined as string | undefined,
  padding: undefined as string | undefined,
  contentMarginLeft: '24px' as string | undefined,
  priceMarginTop: '15px',
  buttonHeight: '36px',
  featureWidths: ['108px', '186px', '150px', '120px', '162px'],
};

const AI_LAYOUT = {
  height: '583px',
  borderRadius: '16px',
  maxWidth: '370px' as string | undefined,
  padding: '20px' as string | undefined,
  contentMarginLeft: undefined as string | undefined,
  priceMarginTop: '22px',
  buttonHeight: '42px',
  featureWidths: [
    '108px',
    '186px',
    '150px',
    '120px',
    '162px',
    '140px',
    '170px',
    '132px',
  ],
};

export const ProductCardsSkeleton = ({
  numCards = 4,
  dataHook = 'product-cards-skeleton',
  isAiRecommendationEnabled = false,
}: ProductCardsSkeletonProps) => {
  const skeletonClassName = styles.skeletonRectangle;
  const layout = isAiRecommendationEnabled ? AI_LAYOUT : DEFAULT_LAYOUT;

  return (
    <ProductCardListUI.Root
      gap={12}
      margin="0 auto"
      width="100%"
      dataHook={dataHook}
    >
      {Array.from({ length: numCards }).map((_, index) => (
        <ProductCardListUI.Card.Root
          key={index}
          width="100%"
          maxWidth={layout.maxWidth}
          borderRadius={layout.borderRadius}
          height={layout.height}
          paddingLeft={layout.padding}
          paddingRight={layout.padding}
        >
          <Box width="100%" height="100%" align="left" direction="vertical">
            <SkeletonGroup>
              <Box
                direction="vertical"
                marginLeft={layout.contentMarginLeft}
                marginTop="74px"
              >
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="20px"
                  width="78px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="120px"
                  marginTop="11px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="33px"
                  width="78px"
                  marginTop={layout.priceMarginTop}
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height={layout.buttonHeight}
                  width="100%"
                  marginTop="30px"
                />
                {layout.featureWidths.map((featureWidth, featureIndex) => (
                  <SkeletonRectangle
                    key={featureIndex}
                    className={skeletonClassName}
                    height="12px"
                    width={featureWidth}
                    marginTop={featureIndex === 0 ? '26px' : '24px'}
                  />
                ))}
              </Box>
            </SkeletonGroup>
          </Box>
        </ProductCardListUI.Card.Root>
      ))}
    </ProductCardListUI.Root>
  );
};
